<section class="main-block">
  <div style="display: flex; flex-direction: column">
    <div style="order: 1">
      <h1>Circana Lightspeed Reporting App</h1>
    </div>
  </div>
  <!-- Section 2 -->
  <div style="display: flex; flex-direction: column">
    <div style="order: 1">
      <p>
        Circana Lightspeed Reporting Application seamlessly integrates with
        Lightspeed point-of-sale, allowing you to streamline the reporting
        process for Circana.
      </p>
    </div>
  </div>
  <!-- Section 3 -->
  <div style="display: flex; flex-direction: column">
    <div style="order: 1; min-height: 500px">
      <h2>Getting started</h2>
      <p>
        Lightspeed is using
        <a href="https://en.wikipedia.org/wiki/OAuth" target="_blank">Oauth2</a>
        protocol to authenticate integrations and grant access to Lightspeed
        API. In order for NPD Reporting App to pull data required for reporting
        purpose, the app must be authorized for access. The app requires the
        following permissions:<br />
      </p>
      <p>
        Please click the Grant Access button below to give Circana Reporting App
        access to Lightspeed API.
      </p>
      <div>
        <button
          id="circana-button-grant-access"
          (click)="onGrantAccessButtonClick()"
        >
          Grant Access
        </button>
      </div>
      <br />
      <p>App Name:<strong>&nbsp;NPD Reporting</strong></p>
      <table style="width: 400px">
        <thead>
          <tr>
            <th>Permission Name</th>
            <th>Access Level</th>
          </tr>
        </thead>
        <tr>
          <td>employee:register</td>
          <td>Read sales history</td>
        </tr>
        <tr>
          <td>employee:inventory</td>
          <td>Read inventory</td>
        </tr>
        <tr>
          <td>employee:admin_shops</td>
          <td>View shops</td>
        </tr>
      </table>
    </div>
  </div>
</section>
